import { Divider, Group } from '@byecode/ui'
import { BACKGROUND_TYPE } from '@lighthouse/core'
import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { AnchorSetting } from '@/components/AnchorSetting'
import type { DesignColorSetting } from '@/components/StyleSetting'
import { DesignSetting, getBlockAndPageDesignLimit, PositionSetting, SizeSetting } from '@/components/StyleSetting'
import AnimationSetting from '@/components/StyleSetting/AnimationSetting'
import { VisibilitySetting } from '@/components/VisibilitySetting'

import { BlockConfigureSegmentedControl } from '../Common/BlockConfigureSegmentedControl'
import { CursorSetting } from '../Common/CursorSetting'
import { SwitchControl } from '../Common/SwitchControl'
import type { BlockSettingsSegmentedEnum } from '../constants'
import { BLOCK_SETTINGS_SEGMENTED_ENUM } from '../constants'

interface UserCenterSettingProps {}

const colorSetting: DesignColorSetting = {
    background: [BACKGROUND_TYPE.color, BACKGROUND_TYPE.variable]
}

export const UserCenterSetting: React.FunctionComponent<UserCenterSettingProps> = props => {
    const { control } = useFormContext()
    const [currentTab, setCurrentTab] = useState<BlockSettingsSegmentedEnum>(BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN)
    const styleProps = getBlockAndPageDesignLimit('userCenter')

    return (
        <>
            <BlockConfigureSegmentedControl value={currentTab} onChange={setCurrentTab} />
            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN && (
                <>
                    <PositionSetting {...styleProps.position} />
                    <Divider />
                    <SizeSetting {...styleProps.size} />
                    <Divider />
                    <Group label="样式">
                        <DesignSetting colorLabel="文字/图标颜色" {...styleProps.design} colorSetting={colorSetting} />
                    </Group>
                    <Divider />
                    <Controller name="cursor" render={({ field }) => <CursorSetting {...field} />} />
                </>
            )}
            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.CONFIGURE && (
                <>
                    <Group label="头像">
                        <Controller
                            name="showUserSetting"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <SwitchControl
                                    label="显示账号设置"
                                    checked={value}
                                    onChange={e => {
                                        onChange(e.currentTarget.checked)
                                    }}
                                />
                            )}
                        />
                    </Group>
                    <Divider />
                    <AnchorSetting />
                    <Divider />
                    <VisibilitySetting />
                </>
            )}
            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.INTERACTION && <AnimationSetting />}
        </>
    )
}
